/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for French(Canada) language
 *
 * @file fr-ca.js
 * @author Manimaran.S
 */

const frca = {
  'popularChannelSlider.allChannels': 'Tous les canaux',
  'popularChannelSlider.recommended': 'Recommandé',
  'hero.myetextbook.link': 'bibliothèque',
  'hero.myetextbook.text': 'Pas le bon titre? Accédez à votre livre électronique',
  'hero.etextfeaturestitle': 'Trouver du matériel d’étude dans votre livre électronique',
  'hero.etextfeaturesdescription': 'Votre livre électronique est accompagné de matériel d’étude conçu pour vous aider à réussir. Étudiez avec des cartes éclairs et plus encore, directement dans votre livre électronique.',
  'aichat.title1': 'Obtenez une aide alimentée par l’IA pour tout ce qui concerne ce livre électronique.',
  'aichat.chatDesc1': 'Saisissez une question pour commencer',
  'subscriptiontext.isSubscribed': 'Partie de votre abonnement',
  'subscriptiontext.nonSubscriber': 'Mise à niveau pour un accès complet',
  'topicConatiner.otherHeader': 'Vidéos et exercices connexes',
  'topicConatiner.exactLiteHeader': 'Concepts et exercices connexes',
  'moremenu.downloadApp': 'Télécharger l\'application mobile',
  'moremenu.downloadAppAlreadyDownload': '%Click here% pour télécharger l’appli sur un autre appareil et vous connecter automatiquement ou pour utiliser votre code QR unique afin de vous connecter en toute sécurité sur l’appli que vous avez déjà installée.',
  'moremenu.downloadAppNotDownload': '%Click here% pour télécharger l’appli et vous connecter en toute sécurité avec votre code QR unique',
  'channel.noBundletitle': 'Utilisez la préparation à l’étude pour vos cours connexes et autres cours',
  'onboard.studyPlan': 'Plan d’étude personnalisé créé!',
  'onboard.addCourseAnother': 'Souhaitez-vous ajouter un autre cours?',
  'onboard.purchase': 'J\'ai besoin d\'acheter un manuel scolaire électronique de Pearson',
  'onboard.addCourseWithoutEtext': 'Ajoutez des cours à l’aide de la préparation à l’étude',
  'onboard.mayBeLater': 'Peut être plus tard',
  'onboard.aboutCourse': 'Parlez-nous de votre cours',
  'onboard.close': 'Fermer',
  'course.addTitle': 'Ajouter un cours',
  'common.PURCHASE': 'Acheter',
  'common.CLOSE': 'Fermer',
  'open': 'ouvrir',
  'continue': 'Continuer',
  'yes': 'Oui',
  'no': 'Non',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': 'Réussite!',
  'courses.toc.PUBLISH_MESSAGE': 'Les étudiants apercevront les modifications la prochaine fois qu\'ils ouvriront le contenu.',
  'errors.GENERIC_TITLE': 'Vous n\'y avez pas accès pour le moment',
  'errors.GENERIC_DESC': 'Commencez par actualiser ou vider votre cache. Si cela ne fonctionne pas, contactez Pearson. ',
  'errors.GENERIC_LINK': 'soutien.',
  'errors.GENERIC_CODE': 'Code d’erreur : {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'L\'abonnement n\'a pu être trouvé.',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Votre compte ne comprend pas l\'accès à ce titre. Si vous estimez avoir reçu ce message par erreur, veuillez communiquer avec le Soutien technique de Pearson.',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'L\'abonnement n\'a pu être trouvé.',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Votre abonnement ne comprend pas l\'accès au eText, vous pouvez toutefois vous abonner à celui-ci à l\'aide de votre carte de crédit.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://pearsonerpi.com/aide',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'My account (Mon compte)',
  'menu.helpCenter': 'Centre d’aide',
  'menu.preferencesCenter': 'Centre de préférences',
  'menu.CONTACT_SUPPORT': 'Communiquer avec le Soutien',
  'menu.HELP_SUPPORT': 'Aide et support technique',
  'menu.FAQS': 'FOIRE AUX QUESTIONS',
  'menu.CHAT_WITH_SUPPORT': 'Converser avec le support',
  'menu.OTP_CODES': 'Codes OTP',
  'menu.LAUNCH_CODE': 'Lancer le journal de code',
  'menu.SEND_CODE': 'Envoyer un nouveau code d’utilisateur par courriel',
  'menu.SEND_CODE_PHONE': 'Envoyer un nouveau code d’utilisateur via message texte',
  'menu.LEGAL': 'Département juridique',
  'menu.PRIVACY_NOTICE': 'Avis de confidentialité',
  'menu.TITLE_INFO': 'Informations sur le titre',
  'menu.PEARSON_ACCESSIBILITY': 'Accessibilité Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Enregistrez {deviceLimit} appareils. Échange 1 par mois.',
  'menu.ACCESSIBILITY': 'Accessibilité',
  'menu.ACCESSIBILITY_SUPPORT': 'Soutien à l\'accessibilité',
  'menu.DEVICES': 'Appareils récents',
  'menu.THIS_DEVICE': 'Cet appareil',
  'menu.GET_THE_APP_DOWNLOAD': 'Télécharger l\'application mobile',
  'menu.MOJO_APP_INFO': 'Rendez-vous dans la boutique d\'applications de votre téléphone ou de votre tablette pour utiliser Pearson+ hors ligne.',
  'menu.DEVICE_LABEL': 'Appareil',
  'menu.DEVICE_DISCONNECT': 'Débrancher',
  'menu.FOXIT': 'Optimisé par FoxIT',
  'menu.TERMS_OF_USE': 'Conditions d\'utilisation',
  'menu.SIGN_OUT': 'Se déconnecter',
  'menu.PRINT_PAGE': 'Imprimer la page',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. Tous droits réservés.',
  'print.FOOTER_MESSAGE': 'Imprimé par {fullName}({email}) sur {currentDate}.',
  'print.WATERMARK': 'Droit d\'auteur © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Vous avez déjà échangé ce mois-ci',
  'device.SWITCH_DEVICE': 'Passer à l\'appareil actuel?',
  'device.SWITCH_ONCE': 'Puisque vous ne pouvez changer qu\'une fois par mois, vous ne pourrez pas annuler cette action.',
  'device.SEAT_TAKEN': 'Ce siège est occupé.',
  'device.DISCONNECT_DEVICE': 'Vous ne pouvez vous connecter qu\'à 3 appareils. Pour continuer ici, débranchez un autre appareil.',
  'device.ALERT_TEXT': 'Souvenez-vous, vous ne pouvez échanger des appareils qu\'une fois par mois.',
  'device.DISCONNECT': 'Débrancher',
  'device.CONTINUE': 'Continuer',
  'device.HEADER': 'Fermer votre autre session de navigation?',
  'device.CLOSE': 'Retour à l\'accueil',
  'device.CODE': 'Continuez ici en saisissant le code d’authentification que nous vous avons envoyé à {maskedEmail}. Cela ne fonctionne pas? Vérifiez vos pourriels, {email}, ou communiquez avec {support}.',
  'device.TIMER': 'Vous devez {time} saisir votre code ici',
  'device.RESEND': '{resend}',
  'device.FAQ': 'FAQ',
  'device.RESEND_NAME': 'Renvoyer',
  'device.NOTE': 'Si vous utilisez régulièrement Pearson+ à deux endroits différents, par exemple au travail et à la maison, veillez à vous déconnecter chaque fois que vous avez terminé. Vous pouvez également utiliser l\'application mobile Pearson+ sur deux appareils au maximum. Pour plus d\'informations, consultez notre {faq}',
  'device.NOTE_HEADER': 'À éviter la prochaine fois',
  'device.CONTACT_SUPPORT': 'support technique',
  'device.CONTACT_EMAIL': 'mettez à jour votre courriel',
  'device.INCORRECT': 'Erreur : vérifiez votre code ou renvoyez-le.',
  'device.MANY_ATTEMPTS': 'Trop de tentatives, essayez de renvoyer le code',
  'device.EXPIRED': 'Votre temps a expiré, essayez de renvoyer le code',
  'device.ACCESS_HEADER': 'Vous êtes entré!',
  'device.ACCESS_DESC': 'Votre session a été authentifiée. Vous voulez mettre votre mot de passe à jour pendant que vous y êtes?',
  'device.ACCESS_CHANGE_PASSWORD': 'Modifier le mot de passe',
  'device.ACCESS_RESET_PASSWORD': 'Réinitialisez le mot de passe',
  'device.THREATONE_TITLE': 'Tout est ok?',
  'device.THREATONE_DESC': 'Nous remarquons une activité suspecte sur votre compte.',
  'device.THREATONE_DESC_TWO': 'C\'est le bon moment pour changer votre mot de passe.',
  'device.MAY_BE_LATER': 'Peut être plus tard',
  'device.OKAY': 'OK',
  'device.ACCOUNT_LOCK_DESC': 'Pour assurer votre sécurité, nous vous avons déconnecté. Nous vous avons également envoyé un lien de réinitialisation de mot de passe au courriel associé à votre compte.',
  'device.ACCOUNT_LOCK_TITLE': 'Nous avons remarqué une activité suspecte sur votre compte',
  'device.ACCOUNT_LOCK_TIMER': 'Vous serez déconnecté dans {time}',
  'navigation.PAGE': 'Page',
  'launchcode.CREATEBY': 'Créé par :',
  'launchcode.sentvia': 'Envoyé via:',
  'launchcode.CODEINLAST': 'Codes des 7 derniers jours :',
  'launchcode.TIMESENT': 'Heure envoyée :',
  'launchcode.ACCOUNTEMAIL': 'Courriel de compte :',
  'launchcode.LAUNCHDIALOGTITLE': 'Journal des codes OTP',
  'textmessage.TITLE': 'Saisissez votre numéro de téléphone',
  'textmessage.PHONE_NUMBER': 'Numéro de téléphone',
  'textmessage.SEND_CODE': 'Envoyer le code',
  'textmessage.INVALID_NUMBER': 'Numéro de téléphone invalide.',
  'textmessage.SUCCESS_MESSAGE': 'Code envoyé',
  'remove.title': 'Supprimer le titre?',
  'remove.subTitle': 'Vous pouvez toujours la récupérer plus tard - il suffit d\'utiliser la recherche pour l\'ajouter à nouveau.',
  'remove.buttonText': 'Supprimer',
  'search.searchPlaceHolderPPlus': 'Effectuer une recherche par ISBN, titre ou auteur',
  'search.searchPlaceHolderEText': 'Recherchez votre bibliothèque',
  'footer.downloadMobileApp': 'Télécharger l\'application mobile',
  'footer.termsOfUse': 'Conditions d\'utilisation',
  'footer.privacy': 'La confidentialité',
  'footer.cookies': 'Les témoins (« cookies »)',
  'footer.doNotSellMyPersonalInformation': 'Ne pas vendre mes renseignements personnels',
  'footer.accessibility': 'Accessibilité',
  'footer.patentNotice': 'Avis de brevet',
  'footer.copyrights': 'Pearson Tous droits réservés.',
  'hero.toc.defaultPlacehoder': '--- Sélectionnez un thème ---',
  'hero.openEtextBookV1': 'Ouvrir le livre électronique',
  'hero.heroHeading': 'Parce que vous étudiez <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Préparation à l’étude',
  'hero.study.help': 'Obtenez une aide à l’étude',
  'hero.study.jumpBackIn': 'Revenir en arrière',
  'hero.study.numOfUsers': 'Il y a présentement <b>{num_of_users}</b> étudiants qui utilisent vos Canaux.',
  'hero.heroChannel.cardsHeading': 'Poursuivre là où vous vous êtes arrêté',
  'hero.marketingcard1.copy.title': 'Apprendre avec des vidéos',
  'hero.marketingcard1.copy.description': 'Regardez des vidéos d’explication qui décomposent les sujets délicats.',
  'hero.marketingcard2.copy.title': 'Problèmes d’entraînement',
  'hero.marketingcard2.copy.description': 'Préparez votre examen avec des milliers de questions similaires à celles de l\'examen et des solutions vidéo',
  'hero.marketingcard3.copy.title': 'Obtenir de l’aide qualifiée',
  'hero.marketingcard3.copy.description': 'Posez des questions et obtenez des réponses d’experts en la matière.',
  'hero.popularTopics.heading': 'Autres sujets populaires sur ce Canal',
  'hero.popularChannels.headingv1': 'Vous voulez suivre un autre cours?',
  'hero.popularChannels.descriptionv2': 'Parcourez les sujets d\'aide à l\'étude les plus populaires.',
  'hero.practice': 'Pratique',
  'hero.herobook.mappedChannelHeading': 'Aide à l\'étude recommandée sur ce Canal',
  'libraryL2.myBooks': 'Mes livres',
  'libraryL2.archived': 'Archivé',
  'libraryL2.back': 'Retour',
  'hero.practiceProblem': 'Problème pratique',
  'nativeAppBanner.drawer.title': 'Ouvrir dans ...',
  'nativeAppBanner.drawer.pearsonApp': ' Appli Pearson+',
  'nativeAppBanner.banner.title': ' Appli Pearson+',
  'nativeAppBanner.banner.description': 'Écouter sur la route',
  'hero.promotionalcard.list1': 'Des petites vidéos qui décomposent les sujets délicats.',
  'hero.promotionalcard.list2': 'Des milliers de questions similaires à celles de l’examen',
  'hero.promotionalcard.list3': 'Obtenez des réponses d’experts en la matière',
  'hero.studyandexamprep': 'Préparation à l’étude',
  'hero.heroBook.sectionSubHeadingV1': 'Décomposez les sujets difficiles avec des questions pratiques et des explications vidéo adaptées à votre cours.',
  'hero.heroBook.sectionSubHeadingV2': 'Décomposez les sujets difficiles avec des questions pratiques et des explications conceptuelles adaptées à votre cours.',
  'hero.SeeAllStudyOptions': 'Voir toutes les options d\'études',
  'hero.herobook.mappedChannelHeadingV1': 'Vidéos recommandées et questions d’entraînement',
  'hero.popularTopics.headingV1': 'Autres thèmes populaires',
  'hero.heroHeadingV1': 'Pour <span>{replace_value}</span>',
  'hero.learnmore': 'En savoir plus',
  'hero.eTextbook': 'Manuel scolaire électronique',
  'hero.goToPage.label': 'Aller à la page',
  'subscription.studyTitle': 'Préparation à l’étude',
  'print.printAvailTitle': 'Vous souhaitez imprimer cette page? Voici comment',
  'print.printAvailDesc': 'Dans votre livre électronique, sélectionnez l’icône du compte en haut à droite. Dans les options, choisissez « Imprimer la page » et choisissez vos paramètres d’impression.',
  'print.printNotAvailTitle': 'L\'option d\'impression de cet eText n\'est pas activée.',
  'print.printNotAvailDesc': 'Pour pouvoir y accéder facilement hors ligne, téléchargez votre titre via l\'application mobile Pearson+ et profitez de la possibilité d\'étudier quand vous le souhaitez, où que vous soyez !',
  'hero.header.cta': 'Accéder aux outils d\'étude',
  'hero.header.ctav2': 'Ouvrir la préparation à l’étude',
  'hero.marketing.title': 'Trouvez votre eTextbook (Manuel scolaire électronique)',
  'hero.marketing.subTitle': 'Choisissez parmi plus de 2000 livres électroniques avec audio, cartes éclairs, notes, et plus encore. Seulement 10,99 $/mois pour une durée de 4 mois.',
  'hero.popularchannels.desc': 'Obtenez une aide à l’étude avec ces matières en demande.',
  'hero.removecourse.title': 'Supprimer un cours du tableau de bord?',
  'hero.removecourse.description': 'Vous pouvez toujours réintégrer ce cours dans votre tableau de bord en cliquant sur « Ajouter un cours »',
  'hero.removecourse.primaryCtaText': 'Supprimer',
  'hero.removecourse.secondaryCtaText': 'ANNULER',
  'hero.tableOfContents': 'Table des matières',
  'hero.search': 'Rechercher',
  'hero.emptystate.cta': 'Rechercher les livres électroniques',
  'hero.watch_it_again': 'Regarder à nouveau',
  'hero.mondly.learnLang.title': 'Apprendre une nouvelle langue gratuitement',
  'hero.mondly.subTitle': 'Les utilisateurs de livres électroniques de Pearson bénéficient de trois mois gratuits sur Mondly.',
  'hero.mondly.description': 'La plupart d’applications d’apprentissage vous donnent uniquement la possibilité d’apprendre l’anglais. Pourtant, l’idéal serait d’apprendre en partant de sa langue maternelle. C’est dans cette optique que Mondly vous permet d’apprendre une de nos 41 langues.',
  'hero.mondly.startLearningCTA': 'Commencez à apprendre',
  'hero.mondly.marketing.bestApp': 'Meilleure application',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Application de l\'année',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - Lauréat EMEA 2017',
  'hero.mondly.marketing.editorChoice': 'Choix de la rédaction',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Apprendre une langue',
  'header.menu.moreAtPearson': 'Plus chez Pearson',
  'hero.subscriptionStatusTitle2': 'Vos ressources Pearson+',
  'hero.startStudying': 'Commencer l’étude',
  'onboard.studyMaterials': 'Choisissez votre matière et nous créerons un tableau de bord avec du matériel d\'étude personnalisé.',
  'hero.myETextbooks': 'Mes manuels scolaires électroniques (eTextbooks)',
  'header.continueInTheApp': 'Continuer sur l’application',
  'hero.learnTxt': 'Apprendre',
  'hero.examPrepTxt': 'Préparation aux examens',
  'hero.aITutorTxt': 'Tuteur IA',
  'AI.toolTip': 'Posez-moi des questions sur tout ce qui se trouve dans votre livre électronique',
  'hero.studyExamPrepAllYourCourses': 'La préparation à l’étude pour tous vos cours',
  'header.qrCode.subHeaderTxt': 'Utilisez ce code QR pour vous connecter rapidement et en toute sécurité à l’appli Pearson+ sur votre appareil mobile.',
  'header.qrCode.dontHaveApp': 'Vous n’avez pas de l’appli?',
  'header.qrCode.footerTxt': 'En balayant ce code, vous serez redirigé vers l’App Store ou Google Play. Une fois l’appli téléchargée, connectez-vous en scannant à nouveau le code.',
  'header.qrCode.errorMsg': 'Le code QR n’a pas été chargé. Veuillez fermer et réessayer.',
  'hero.yourETextbook': 'Votre livre électronique',
  'onboard.addCourseWithEtextBundle': 'Ajoutez des cours à l’aide de la préparation à l’étude',
  'onboard.disableTooltipText': 'Tous les cours de préparation à l’étude sont ajoutés!',
  'subscriptionstatus.bundlecta': 'Accédez à la préparation à l’étude',
  'subscriptionstatus.nonbundlecta': 'Accédez à la préparation à l’étude',
  'channel.genericBundle': 'Utilisez la préparation à l’étude pour obtenir de l’aide dans vos autres cours',
  'channel.relatedBundle': 'Utilisez aussi la préparation à l’étude pour obtenir de l’aide dans vos autres cours',
  'onboard.courseAdded': 'Cours ajouté!',
  'hero.flashcards': 'Cartes éclairs',
  'relatedChannelCard.title': 'Améliorez votre apprentissage avec cette ressource connexe',
  'relatedChannelCard.badgeText': 'Programmes de préparation à l’étude connexes',
  'sessionInactivity.title': 'Vous êtes encore là?',
  'sessionInactivity.description': 'Votre session va expirer dans <b>%TIMER%</b> pour cause d’inactivité.<br/>Souhaitez-vous rester connecté(e)?',
  'sessionInactivity.keepMeSignIn': 'Gardez ma session ouverte',
  'sessionInactivity.signOut': 'Se déconnecter',
  'sessionTimeout.title': 'Session expirée',
  'sessionTimeout.description': 'Votre session a expiré pour cause d’inactivité.',
  'print.qrCode.header': 'Utilisez ce code QR pour ouvrir l’appli Pearson+ sur votre appareil mobile.',
  'print.qrCode.footer': 'En balayant ce code, vous serez redirigé vers l’App Store ou Google Play. Une fois l’appli installée, connectez-vous pour télécharger et accéder à votre titre.',
  'hero.nestest.title': 'Préparez-vous à l\'examen du brevet d’enseignement',
  'hero.nestest.subTitle': 'Les utilisateurs de Pearson+ peuvent désormais accéder à des cours de préparation et à des tests blancs conformes aux programmes nationaux afin de se préparer à leurs examens du brevet d’enseignement.',
  'hero.channelAI.title': 'Besoin d\'aide ? Le tuteur IA est là pour vous aider.',
  'hero.channelAI.desc': 'Posez une question et obtenez une aide aux devoirs étape par étape, des recommandations, et plus encore – une aide personnalisée, dès que vous en avez besoin.',
  'hero.channelAI.action': 'Demander au tuteur IA',
  'new': 'Nouveau!',
  'hero.practice.numOfUsers': 'Cette section comporte <b>{practice_num_of_users}</b> problèmes pratiques.',
  'hero.practice.cta': 'Exercez-vous maintenant',
  'hero.practice.title': 'Problème pratique',
  'diagnostics.errorMsg': 'Le diagnostic n’a pas pu être chargé. Veuillez fermer et réessayer.',
  'qrcode.title': 'Commencer à étudier où vous voulez',
  'qrcode.subtitle': 'Apprenez où vous voulez, quand vous voulez, grâce à l\'application mobile Pearson+. Téléchargez-la dès maintenant et profitez d\'une expérience d\'apprentissage fluide.',
  'qrcode.detailsv1': 'Grâce à l\'application Pearson+, vous pouvez utiliser ce code QR pour reprendre là où vous vous êtes arrêté. Parcourez votre livre, étudiez à l\'aide de fiches, regardez des leçons vidéo et bien plus encore, où que vous soyez.',
  'qrcode.detailsv2': 'Scannez ce code QR chaque fois que vous souhaitez vous connecter rapidement et reprendre là où vous vous étiez arrêté.',
  'qrcode.details': 'Grâce à l\'application Pearson+, vous pouvez utiliser ce code QR pour reprendre là où vous vous étiez arrêté.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Apprenez où vous voulez, quand vous voulez, grâce à l\'application mobile Pearson+. Téléchargez-la dès maintenant et profitez d\'une expérience d\'apprentissage fluide.',
  'install': 'Install',
  'header.menu.createCourse': 'Nouveau Cours',
  'header.dropdown.courses': 'Cours',
  'header.dropdown.recentlyViewed': 'Récemment consulté',
  'header.dropdown.viewAll': 'Afficher tous les cours',
  'aet.courseHeader.inviteStudents': 'Inviter les étudiants',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Invitez les étudiants à accéder à ce manuel scolaire électronique en copiant l\'adresse du lien ou les instructions ci-dessous dans votre courriel ou votre programme de cours.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Adresse du lien',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Copier le lien',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instructions avec lien',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Copier les instructions',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'It\'s time to access {bookTitle} the eTextbook for {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'When you\'re ready, access your eTextbook at: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Il vous sera demandé de vous connecter à l\'aide de votre compte Pearson actuel. Si vous n\'avez pas de compte Pearson, vous pourrez en créer un.  ',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Need help? ',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Date de début :',
  'aet.courseHeader.endDate': 'Date de fin :',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format :',
  'aet.home.manageroster': 'Gérer la liste',
  'aet.home.managegradesync': 'Gérer la synchronisation des notes',
  'aet.home.copycourse': 'Copier le cours',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.instructorCourse.tabs.current': 'En cours',
  'aet.instructorCourse.tabs.past': 'Passé',
  'aet.instructorCourse.tabs.courseSettings': 'Réglages du cours',
  'aet.instructorCourse.tabs.manageRoster': 'Gérer la liste',
  'aet.instructorCourse.currentCourses.title': 'Cours actuels',
  'aet.instructorCourse.pastCourses.title': 'Cours précédents',
  'aet.instructorCourse.createOrCopy.title': 'Créer ou copier un cours',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Copier le cours d\'un autre instructeur ou en créer un nouveau',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Copier le cours d\'un autre instructeur',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Saisir l\'identifiant du cours pour trouver celui que vous souhaitez copier.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Identifiant du cours',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Saisir l\'identifiant du cours',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Vous avez recherché par',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Créer un nouveau cours à partir du catalogue',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Rechercher par titre, auteur, ISBN ou mots-clés thématiques.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Recherche en cours...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Afficher plus',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Afficher moins',
  'aet.instructorCourse.cancel': 'ANNULER',
  'aet.instructorCourse.loading': 'Chargement en cours...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Synchronisation des notes',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Gérer la synchronisation des notes',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nom du cours',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Sans titre',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nom de la section',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Sans titre',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institution',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'L\'institution est requise.',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Une erreur s\'est produite. Veuillez réessayer.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Aucun résultat',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another Institution',
  'aet.instructorCourse.courseForm.startDateLabel': 'Date de début du cours',
  'aet.instructorCourse.courseForm.endDateLabel': 'Date de fin du cours',
  'aet.instructorCourse.courseForm.datePlaceholder': 'jj/mm/aa',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Autoriser les autres à copier ce cours',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Partager ce code avec les instructeurs qui souhaitent copier ce cours',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Copier le code',
  'aet.instructorCourse.courseForm.optionalSuffix': '(Optionnel)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Le formulaire présente des erreurs de validation',
  'aet.instructorCourse.courseForm.submitContinue': 'Continuer',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Enregistrement en cours...',
  'aet.instructorCourse.courseForm.submitError': 'Nous n\'avons pas pu créer votre cours. Veuillez réessayer.',
  'aet.instructorCourse.courseForm.submitEditError': 'Nous n\'avons pas pu enregistrer vos modifications. Veuillez réessayer.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Enregistrer les modifications',
  'aet.instructorCourse.courseForm.materialsHeader': 'Supports de cours',
  'aet.instructorCourse.courseForm.resolveError': 'Nous n\'avons pas pu charger les supports de cours. Veuillez réessayer.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Dernière consultation',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Récemment ajouté',
  'aet.instructorCourse.coursesSort.aToZ': 'A à Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z à A',
  'aet.instructorCourse.manageRoster.column.name': 'Nom',
  'aet.instructorCourse.manageRoster.column.role': 'Rôle',
  'aet.instructorCourse.manageRoster.column.email': 'Courriel',
  'aet.instructorCourse.manageRoster.column.status': 'Statut',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Enrolled {date}',
  'aet.instructorCourse.manageRoster.notAvailable': '--',
  'aet.instructorCourse.roster.role.student': 'Étudiant',
  'aet.instructorCourse.roster.role.ta': 'AE',
  'aet.instructorCourse.roster.role.instructor': 'Instructeur',
  'aet.instructorCourse.roster.status.active': 'Actif',
  'aet.instructorCourse.roster.status.inactive': 'Inactif',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Tous les membres',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Étudiants actifs',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Étudiants inactifs',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Assistant d’enseignement',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instructeur',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Auteur :',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Date de création du cours :',
  'aet.instructorCourse.noCoursesFound': 'Aucun cours trouvé',
  'aet.instructorCourse.backButton': 'Retour',
  'aet.instructorCourse.selectCourse': 'Sortir du cours',
  'aet.home.linkedToLms': 'Lié au LMS',
  'aet.instructorCourse.courseForm.title.create': 'Créer un cours',
  'aet.instructorCourse.courseForm.title.copy': 'Copier le cours',
  'aet.instructorCourse.courseForm.title.edit': 'Informations sur le cours',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Affectations',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Contenu du devoir',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Dates d\'échéance des devoirs',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Contenus surlignés et notes',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Couleur surlignée',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Texte de la note',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Statut partagé',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Liste des étudiants et implication',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Noms des élèves',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Adresses courriels',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Inscription',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Réalisation et analyses',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Paramètres',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Données copiées',
  'aet.studentRoster.manageStudentRosterButton': 'Gérer la liste des étudiants',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.assignments.exportStudentProgressButton': 'Exporter la progression des élèves',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Statut :',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Inscrit :',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Rôle :',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promote  {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'En tant qu\'assistant(e) d\'enseignement, cette personne pourra suivre les progrès et les résultats de tous les élèves de cette classe.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Ils pourront également gérer les étudiants et les devoirs, mais ils ne pourront pas supprimer la classe.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promouvoir au poste d\'assistant d\'enseignement',
  'aet.home.manageRoster.searchPlaceholder': 'Rechercher des élèves',
  'aet.home.manageRoster.inactivateButtonLabel': 'Désactiver les élèves sélectionnés',
  'aet.home.manageRoster.FilterLabel': 'Show',
  'aet.home.manageRoster.updatingMessage': 'Mise à jour de la liste... Cela peut prendre quelques minutes.',
  'aet.home.courses.search.searchPlaceHolder': 'Chercher des cours',
  'aet.courses.emptyStateDescription': 'Commencez à créer votre cours en choisissant l\'une des options ci-dessous.',
  'nativePromoBanner.continueInBrowser': 'Continuer dans le navigateur',
  'globalnav.tooltip.hideNavText': 'Masquer la navigation',
  'globalnav.tooltip.showNavText': 'Afficher la navigation',
  'aet.syllabus.progressTitle': 'En cours d’extraction...',
  'aet.syllabus.progressDesc': 'Veuillez patienter pendant que nous traitons votre programme de cours.',
  'aet.syllabus.uploadInputLabel': 'Faites glisser et déposez vos fichiers ici ou cliquez pour les téléverser',
  'aet.syllabus.uploadSyllabusTabLabel': 'Téléverser le programme',
  'aet.syllabus.dateAdjusterTabLabel': 'Réglage de la date',
  'aet.syllabus.addManuallyTabLabel': 'Ajouter à la main',
  'aet.syllabus.addEditLaterText': 'Vous pouvez toujours ajouter et modifier des devoirs ultérieurement.',
  'aet.syllabus.editAssignmentLabel': 'Modifier un devoir',
  'aet.syllabus.addAssignmentLabel': 'Ajouter un devoir',
  'aet.syllabus.assignmentTitleLabel': 'Titre du devoir',
  'aet.syllabus.dueDateLabel': 'Date d’échéance',
  'aet.syllabus.editDueDateLabel': 'Modifier la date d\'échéance',
  'aet.syllabus.chaptersCoveredLabel': 'Sélectionnez les chapitres ou les sections à couvrir.',
  'aet.syllabus.updateCtaLabel': 'Mettre à jour le devoir',
  'aet.syllabus.addCtaLabel': 'Ajouter un devoir',
  'aet.syllabus.uploadLabel': 'Télécharger',
  'aet.syllabus.confirmLabel': 'Confirmer',
  'aet.syllabus.updateDatesLabel': 'Mettre à jour la date',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Your due date was updated. Review it, then publish.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Your chapter/section information was updated. Review it, then publish.',
  'aet.syllabus.unassignedCoverageStatus': 'Some chapters are not assigned yet. Assign them before you publish.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.deleteAssignmentTitle': 'Supprimer le devoir?',
  'aet.deleteAssignmentTitleMultiple': 'Supprimer les devoirs?',
  'aet.deleteAssignmentWarning': 'Cette action n\\e peut pas être annulée, et toutes les soumissions et données étudiantes associées ne seront plus visibles.',
  'aet.deleteAssignmentKeepCTA': 'Garder le devoir',
  'aet.deleteAssignmentDeleteCTA': 'SUPPRIMER',
  'aet.assignments.loadingAsset': 'Chargement de l’actif...',
  'aet.assignments.allCaughtUpDescription': 'Aucun devoir à rendre cette semaine.',
  'aet.assignments.progressTitle': 'Progrès',
  'aet.assignments.performanceTitle': 'Confiance',
  'aet.assignments.completionTitle': 'Fin',
  'aet.assignments.statusTitle': 'Statut',
  'aet.assignments.addTooltip': 'Ajouter un devoir',
  'aet.assignments.deleteTooltip': 'Supprimer les devoirs sélectionnés',
  'aet.assignments.selectToDeleteLabel': 'Mode sélection et suppression',
  'aet.assignments.bulkEditTooltip': 'Modifier plusieurs devoirs à la fois',
  'aet.assignments.title': 'Affectations',
  'aet.assignments.assignmentTitle': 'Devoir',
  'aet.assignments.dueDate': 'Date d’échéance',
  'aet.tabular.searchPlaceholder.assignments': 'Rechercher des devoirs',
  'aet.tabular.searchPlaceholder.students': 'Rechercher des étudiants',
  'aet.tabular.searchPlaceholder.questions': 'Rechercher des questions',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Un ou plusieurs étudiants bénéficient d\'un report de la date d’écheance pour tous les devoirs',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Un ou plusieurs élèves bénéficient d\'un report de la date d\'échéance pour ce devoir',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Un ou plusieurs étudiants ont bénéficié d\'un report de la date d\'échéance. Pour identifier ces devoirs, cherchez l\'icône Info.',
  'aet.home.loading': 'Chargement en cours...',
  'aet.home.errorFetchingAssignments': 'Erreur lors de la récupération des devoirs',
  'aet.home.dueThisWeekTitle': 'Dû cette semaine',
  'aet.home.allCaughtUpTitle': 'Vous êtes à jour!',
  'aet.home.allCaughtUpDescription': 'Aucun devoir à rendre cette semaine.',
  'aet.home.suggestedRemediationTitle': 'Révision proposée par la préparation à l\'étude',
  'aet.home.noSuggestedRemediationTitle': 'Aucun matériel de révision suggéré',
  'aet.home.noSuggestedRemediationDescription': 'Revenez après votre prochain devoir.',
  'aet.home.assignmentIncludesTitle': 'Le devoir comprend',
  'aet.home.sectionsLabel': 'Chapitre(s)',
  'aet.home.questionsCount': '{count} questions',
  'aet.home.dueLabel': 'Échéance : {dueDate}',
  'aet.home.due': 'Dû :',
  'aet.home.progressCompletedLabel': 'Complété',
  'aet.home.progressCompletedPastDueLabel': 'Complété en retard',
  'aet.home.progressInProgressLabel': 'En cours',
  'aet.home.progressNotStartedLabel': 'Pas commencé',
  'aet.home.progressCountOfTotal': '{count} de {total}',
  'aet.home.NotAttemptedLabel': 'Non tenté',
  'aet.home.questionsTotalLabel': 'Total des questions',
  'aet.home.progressCompletedOnTimeLabel': 'Terminé à temps',
  'aet.home.segmentGreatLabel': 'Parfait',
  'aet.home.segmentGettingThereLabel': 'OK',
  'aet.home.segmentNeedsReviewLabel': 'Nécessitant un travail supplémentaire',
  'aet.home.segmentOkayLabel': 'OK',
  'aet.home.editAssignmentTooltip': 'Modifier un devoir',
  'aet.home.deleteAssignmentTooltip': 'Supprimer le devoir',
  'aet.home.viewDetailsButton': 'Afficher les détails',
  'aet.home.viewAsStudentButton': 'Voir en tant qu’étudiant',
  'aet.home.welcomeButtonText': 'Pour commencer →',
  'aet.review.emptyStateTitle': 'Rien à réviser.',
  'aet.review.emptyStateDescription': 'Revenez après votre prochain devoir.',
  'aet.dashboard.tabs.upNext': 'Prochaine étape',
  'aet.dashboard.tabs.welcome': 'Bienvenue',
  'aet.dashboard.tabs.assignments': 'Affectations',
  'aet.dashboard.tabs.review': 'Examiner',
  'aet.dashboard.tabs.studentRoster': 'Élèves',
  'aet.dashboard.classSchedule': 'Emploi du temps:',
  'aet.syllabus.dueTimeLabel': 'Délai imparti',
  'hero.accessEducatorGuides': 'Accéder aux guides pédagogiques',
  'aet.assignment.save': 'Enregistrer',
  'aet.assignment.saveAndAdd': 'Enregistrer et ajouter un(e) autre',
  'aet.assignment.delete': 'SUPPRIMER',
  'aet.assignment.saveAndClose': 'Enregistrer et fermer',
  'aet.studentRoster.title': 'Élèves',
  'aet.studentRoster.titlev1': 'Étudiant',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Date d’échéance',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Norme',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 jours',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 jours',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 jours',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 semaine',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 semaines',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Dernier jour de classe',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} devoir mis à jour',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Les devoirs en retard n\'ont pas pu être mis à jour automatiquement. Modifiez-les un par un pour définir une nouvelle date d\'échéance.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Impossible de mettre à jour les dates d\'échéance',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Tous les devoirs sont en retard et n\'ont pas pu être mis à jour automatiquement. Modifiez chacun d\'entre eux pour définir une nouvelle date d\'échéance.',
  'aet.bulkEdit.bulkSplitInstruction': 'Nous répartirons vos tâches de manière équitable.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Premier devoir dû',
  'aet.bulkEdit.lastAssignmentDue': 'Dernier devoir dû',
  'aet.bulkEdit.assignmentsDueDays': 'Quels jours souhaitez-vous que les devoirs soient rendus?',
  'aet.bulkEdit.addEditLaterText': 'Nous utilisons l’IA pour créer des devoirs. Vous pouvez toujours ajouter et modifier des devoirs ultérieurement.',
  'aet.bulkEdit.monday': 'Lundi',
  'aet.bulkEdit.tuesday': 'Mardi',
  'aet.bulkEdit.wednesday': 'Mercredi',
  'aet.bulkEdit.thursday': 'Jeudi',
  'aet.bulkEdit.friday': 'Vendredi',
  'aet.bulkEdit.saturday': 'Samedi',
  'aet.bulkEdit.sunday': 'Dimanche',
  'aet.toast.assignmentCreated.title': 'Devoir créé!',
  'aet.toast.assignmentCreated.single': 'Il a automatiquement reçu le nom {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} des devoirs ont été créés',
  'aet.toast.assignmentUpdated.title': 'La mise à jour a réussi.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} a été mis à jour',
  'aet.toast.assignmentUpdated.multiple': '{count} devoirs ont été mis à jour',
  'aet.toast.viewAssignment': 'Afficher le devoir',
  'aet.toast.viewAssignments': 'Afficher les devoirs',
  'aet.welcome.title': 'Votre manuel scolaire électronique Pearson est maintenant lié à votre cours LMS',
  'aet.welcome.LMSAccounTitle': 'Découvrez les aperçus',
  'aet.welcome.LMSAccounDescription': 'Identifier précisément les thèmes qui posent problème à votre classe.',
  'aet.welcome.createAssignmentsTitle': 'Créer des devoirs',
  'aet.welcome.createAssignmentsDescription': 'Attribuer les chapitres manuellement ou en téléchargeant votre syllabus.',
  'aet.welcome.progressViewTitle': 'Suivre les performances dans votre LMS',
  'aet.welcome.progressViewDescription': 'Choisir les paramètres de synchronisation des notes dans votre cours LMS.',
  'aet.assignmentDetails.noAssignmentFound': 'Aucun devoir trouvé',
  'aet.assignments.loadingErrorTitle': 'La tâche ne peut pas être chargée pour le moment',
  'aet.assignments.loadingErrorDescription': 'Veuillez actualiser la page ou revenir plus tard.',
  'aet.assignmentStudentDetails.noDataFound': 'Aucune donnée pour le moment',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Aucun étudiant n’est inscrit.',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Les étudiants rejoindront votre classe dès qu\'ils auront acheté l’e-textbook.',
  'aet.home.editAssignmentTooltipDisabled': 'Impossible de modifier : travail de l’élève en cours',
  'aet.home.deleteAssignmentTooltipDisabled': 'Impossible de supprimer : travail de l’élève en cours',
  'aet.home.StudentDetails.questions': 'Questions',
  'aet.home.StudentDetails.attempts': 'Tentatives',
  'aet.home.StudentDetails.comprehension': 'Confiance',
  'hero.titleInfo.tooltip': 'Informations sur le titre',
  'aet.home.publishAssignments': 'Publier tous les devoirs',
  'aet.dashboard.footer': 'Certains contenus créés à l’aide de l’IA sont basés sur du matériel pédagogique de Pearson. Bien que Pearson ait mis en place un processus de validation des résultats, l’IA générative peut encore produire des informations inexactes sur des personnes, des lieux ou des faits.',
  'aet.home.bulkEditTitle': 'Modifier les devoirs en masse',
  'aet.home.bulkEditSubtitle': 'Apportez vos modifications à votre programme, puis téléversez-le à nouveau ici. Vos devoirs et dates d’échéance seront mis à jour en conséquence.',
  'aet.home.createAssignmentTitle': 'Créer des devoirs',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Inclure un autre devoir',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Certaines sections sont incluses dans un autre devoir',
  'aet.welcome.welcome.Title': 'Bienvenue!',
  'aet.home.student.roaster.ProgressTitle': 'Achèvement total',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Vérifiez à nouveau une fois que les étudiants auront commencé le devoir.',
  'aet.home.whatDueThisWeekTitle': 'Voici ce qui est prévu cette semaine',
  'aet.assignments.edit.errorTitle': '{count} les devoirs comportent des erreurs',
  'aet.assignments.edit.errorSubTitle': 'Les devoirs contenant des erreurs ne peuvent pas être publiés. Modifiez-les ou publiez-les sans ces erreurs.',
  'aet.assignments.edit.publishAnyway': 'Publier quand même',
  'aet.assignments.edit.editAssignments': 'Modifier les devoirs',
  'aet.assignments.edit.validationInfoToolTip': 'Modifier un devoir pour enlever les erreurs',
  'aet.assignments.error.assignmentCreated.title': 'Tous les devoirs comportent des erreurs',
  'aet.assignments.error.assignmentCreated.description': 'Les devoirs contenant des erreurs ne peuvent pas être publiés. Modifiez-les ou essayez un autre programme de cours.',
  'aet.assignments.error.uploadSyllabus': 'Téléverser le programme',
  'aet.assignments.error.editAssignments': 'Modifier les devoirs',
  'aet.mondly.title': 'Langues',
  'aet.studentRoster.errorState.title': 'Liste des élèves indisponible',
  'aet.studentRoster.errorState.description': 'Nous n’avons pas pu charger votre liste d’élèves. Veuillez actualiser la page ou réessayer plus tard.',
  'aet.assignments.sectionLabel': 'section(s)',
  'aet.assignments.questionsLabel': 'question(s)',
  'aet.assignments.assignmentsLabel': 'devoir(s)',
  'aet.assignments.performanceProgressBar': 'Barre de progression des performances',
  'aet.assignments.completionProgressBar': 'Barre de progression',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Êtes-vous sûr de vouloir supprimer cet devoir ?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Êtes-vous sûr de vouloir supprimer ces devoirs ?',
  'aet.home.nextAssignmentTitle': 'Prochain devoir',
  'aet.home.courseSettings': 'Réglages du cours',
  'aet.home.pearsonETextbookResources': 'Ressources de manuels scolaires électroniques Pearson+',
  'aet.home.etextbookInformation': 'Renseignements sur les manuels scolaires électroniques',
  'aet.multiple.deleteAssignmentKeepCTA': 'Garder le(s) devoir(s)',
  'aet.syllabus.processingText.header': 'Nous organisons les lectures assignées à votre classe; cela ne prendra qu\'un instant.',
  'aet.syllabus.processingText.uploading': 'Téléchargement du document',
  'aet.syllabus.processingText.activating': 'Activation des composants de l’IA',
  'aet.syllabus.processingText.extracting': 'Extraction en cours des lectures obligatoires',
  'aet.syllabus.processingText.mapping': 'Correspondance avec le contenu des manuels scolaires',
  'aet.syllabus.processingText.finishing': 'Finalisation',
  'aet.syllabus.uploadErrorMessage': 'Assurez-vous que votre fichier PDF ou .docx ne dépasse pas 10 Mo et que votre connexion Internet est stable.',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No reading assignments found',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We could not pull reading assignments from this file. You can add them manually.',
  'aet.syllabus.uploadFailedRetryCTA': 'Veuillez réessayer',
  'aet.syllabus.selectChapterWithQuestions': 'Sélectionnez un chapitre contenant une ou plusieurs questions.',
  'preferenceSetting.subTitle': 'Ces paramètres s\'appliqueront par défaut à tous les étudiants inscrits à ce cours.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interactions avec l’IA',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Activer l’outil d’étude IA et les résumés IA dans les résultats de recherche',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Afficher les ressources de préparation à l’étude liées à ce livre',
  'aet.syllabus.footer': 'La création des devoirs est optimisée par l\'IA',
  'aet.dashboard.footerDialogDeatils': 'L\'IA générative est utilisée pour créer des questions de devoirs à partir des supports pédagogiques de Pearson. Bien que Pearson dispose d\'un processus de validation des résultats, l\'IA générative peut néanmoins produire des informations inexactes concernant des personnes, des lieux ou des faits. L\'IA est également utilisée pour regrouper les contenus en devoirs, en fonction du programme et/ou du calendrier que vous fournissez.',
  'aet.review.footer': 'Créé à l’aide de l’IA',
  'aet.footerCard.dismiss': 'Ignorer',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'La préparation à l\'étude est un outil complémentaire qui facilite l\'apprentissage en proposant aux étudiants des vidéos et des exercices adaptés à ce cours.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Les élèves dont le programme d\'accès ne comprend pas la préparation à l\'étude peuvent être invités à s\'abonner afin de continuer à utiliser les ressources de préparation à l\'étude.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Les élèves qui ont déjà acheté la préparation à l\'étude ne seront pas concernés par ce paramètre.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'En savoir plus sur les avantages de la Préparation à l\'étude',
  'aet.home.viewCourseId': 'Voir l’identifiant du cours',
  'aet.home.copy': 'Copier',
  'aet.home.copied': 'Copié',
  'aet.home.courseLabel': 'Identifiant du cours',
  'schoolInfoCard.addUniversity': 'Ajouter une école',
  'schoolInfoCard.title': 'Informations sur l’établissement',
  'schoolInfoCard.titleV1': 'Parlez-nous de votre cours',
  'schoolInfoCard.cta': 'Pour commencer',
  'schoolInfoCard.pickInstitution': 'Choisir une école',
  'schoolInfoCard.addUniversityTitle': 'Ajouter votre école',
  'schoolInfoCard.addUniversitySubtitle': 'En connaissant votre établissement et votre cursus, nous pouvons vous recommander les supports pédagogiques les plus adaptés.',
  'schoolInfoCard.searchPlaceholder': 'Recherchez votre établissement...',
  'schoolInfoCard.skip': 'Ignorer cette étape',
  'schoolInfoCard.nextStep': 'Prochaine étape',
  'schoolInfoCard.notInList': 'Mon établissement n’est pas inclus dans la liste',
  'schoolInfoCard.noResults': 'Aucun établissement trouvé correspondant à votre recherche',
  'schoolInfoCard.noResultsHeading': 'Vous ne trouvez pas votre établissement ?',
  'schoolInfoCard.noResultsInstruction': 'Indiquez votre nom complet ci-dessous',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nom de l’école',
  'schoolInfoCard.addInstitutionLabel': 'Ajouter cette école',
  'aet.assignments.assignmentTitlePlaceholder': 'Saisir un titre',
  'aet.assignments.titleValidation.titleRequired': 'Le titre du devoir est obligatoire.',
  'aet.assignments.titleValidation.titleTooLong': 'Le titre du devoir ne doit pas dépasser {0} caractères.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Le titre du devoir contient des caractères non pris en charge.',
  'aet.assignments.titleValidation.titleDuplicate': 'Le titre du devoir existe déjà',
  'aet.syllabus.timeZoneLabel': 'Fuseau horaire',
  'aet.review.reviewReadingFromAssignments': 'Relire le cours donné pour le devoir',
  'aet.assignments.chaptersLabel': 'chapitre(s)',
  'menu.myAccount.subTitle': 'C\'est ici que se trouve votre institution',
  'menu.myAccount.subTitleNotAvailable': 'Vous pourrez ajouter le nom de cette institution ici plus tard, à tout moment.',
  'schoolInfoCard.toastMessage': 'L\'université a été sauvegardée',
  'aet.review.threeDotMenu.askAI': 'Demander à l’IA',
  'aet.home.suggestedRemediationSubtitle': 'Regarder les vidéos correspondantes et entraînez-vous pour maîtriser les thèmes abordés dans votre cours.',
  'aet.home.laggedQuestionLabel': 'Questions signalées',
  'aet.home.correctAnswer': 'Bonne réponse',
  'aet.home.incorrectAnswer': 'Réponse incorrecte la plus courante',
  'aet.home.behaviourTrendsLabel': 'Analyse des questions',
  'aet.home.strugglingStudentsLabel': 'Élèves en difficulté',
  'aet.home.patternsInStudensAiLabel': 'Modèles d’utilisation de l’IA par les étudiants',
  'aet.home.questionLabel': 'Question',
  'aet.home.studentAskingSimilarQuestions': 'Étudiants posant des questions similaires',
  'aet.home.assignmentDifficultQuestions': 'Questions difficiles',
  'aet.home.behaviorTrends': 'Analyse des questions',
  'aet.home.behaviors': 'Indicateurs de performance',
  'aet.home.mostDifficultTopics': 'Les questions les plus difficiles',
  'aet.home.commentsFromStudentLabel': 'Commentaires des étudiants',
  'aet.home.disregard': 'Ignorer',
  'aet.home.reportAsInaccurate': 'Signaler comme inexact(e)',
  'aet.home.Flagged': 'Signalé',
  'aet.home.reportQuestionTitle': 'Signaler la question',
  'aet.home.reportQuestionLabel': 'Qu’est-ce qui n’allait pas dans cette question?',
  'aet.home.showComments': 'Afficher les commentaires',
  'aet.home.studentReports': 'rapports des étudiants',
  'aet.home.placeholderText': 'Veuillez expliquer...',
  'aet.home.reportQuestion.notRelevant': 'Non pertinent',
  'aet.home.reportQuestion.notCorrect': 'Non correct',
  'aet.home.reportQuestion.unsafe': 'Dangereux/préjudiciable',
  'aet.home.reportQuestion.somethingElse': 'Autre chose',
  'aet.home.StudentDetails.assistedByAI': 'Créé par IA',
  'aet.home.strugglingStudents.emptyStateTitle': 'Aucun étudiant n’éprouve présentement de difficultés.',
  'aet.home.strugglingStudents.emptyStateDescription': 'Veuillez revenir plus tard.',
  'aet.home.overallStatus.excelling': 'Exceller',
  'aet.home.overallStatus.fallingBehind': 'Prendre du retard',
  'aet.home.overallStatus.keepingUp': 'En cours d’acquisition',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Afficher uniquelent les « Questions difficiles »',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Afficher uniquement les « Élèves en difficulté »',
  'aet.home.viewQuestionInAssignment': 'Afficher la question dans le devoir',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Premières tentatives incorrectes',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Beaucoup d’essais incorrects',
  'aet.home.insightRisk.lowConfidence': 'Faible niveau de confiance',
  'aet.home.insightRisk.mediumConfidence': 'Niveau de confiance moyen',
  'aet.home.insightRisk.lowEngagement': 'Implication faible',
  'aet.home.insightRisk.countOfStudents': ' {count} sur {total} étudiants',
  'aet.home.insightRisk.na': 'S/O',
  'aet.home.strugglingStudentsHereLabel': 'Les élèves rencontrent des difficultés ici',
  'aet.home.insightRisk.didNotAttempt': 'N\'a pas essayé',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText'
};

export default frca;
